import type { DatapointStatus, TraceErrorObject } from "owa-analytics-types";
import type { ErrorCodes } from "owa-error-codes";

export function createErrorWithErrorCode(error: TraceErrorObject, errorCode: ErrorCodes, status: DatapointStatus): TraceErrorObject {
    error.owaErrorCode = errorCode;
    error.datapointStatus = status;
    return error;
}
